import { loadStripe } from "@stripe/stripe-js";

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.trim();

const isLocalStripeEnvironment = process.env.NODE_ENV !== "production";
const hasPublishableKey = Boolean(publishableKey);
const hasValidPublishableKey = publishableKey?.startsWith("pk_");
const hasLocalLiveKey =
  isLocalStripeEnvironment && /^(pk_live_|rk_live_)/.test(publishableKey || "");

if (!hasPublishableKey) {
  console.error(
    "Stripe configuration error: REACT_APP_STRIPE_PUBLISHABLE_KEY is required.",
  );
} else if (!hasValidPublishableKey) {
  console.error(
    "Stripe configuration error: REACT_APP_STRIPE_PUBLISHABLE_KEY must be a Stripe publishable key.",
  );
} else if (hasLocalLiveKey) {
  console.error(
    "Stripe configuration error: REACT_APP_STRIPE_PUBLISHABLE_KEY must use a Stripe test key in development and test.",
  );
}

export const stripeConfigured =
  hasPublishableKey && hasValidPublishableKey && !hasLocalLiveKey;
export const stripePromise = stripeConfigured
  ? loadStripe(publishableKey)
  : null;

export const formatMinorAmount = (amount, currency) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  });
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits;
  return formatter.format(amount / 10 ** fractionDigits);
};
